/* @flow */
import React from 'react';
import { Icon, Layout } from 'antd';
import { Footer } from '@/components';
import axios from 'axios';
import config from '@/services/Api/apiConfig';
import { Link } from 'react-router-dom';

const FooterView = () => {
  const fetchPrivacyPolicy = async (fileName) => {
    try {
      const { data } = await axios({
        method: 'get',
        url: `${config.BASE_URI}/api/get_terms_and_policy/`,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });
      if (data) {
        if (fileName === 'privacyPolicy') {
          window.open(data.file.privacy_policy_file, '_blank');
        }
        if (fileName === 'platformAccessAgreement') {
          window.open(data.file.platform_agreement_file, '_blank');
        }
        if (fileName === 'termsAndConditions') {
          window.open(data.file.terms_of_service_file, '_blank');
        }
      }
    } catch (error) {
      alert('Some error occur please try again later', error);
    }
  };

  return (
    <Layout.Footer style={{ padding: 0 }}>
      <Footer
        copyright={
          <>
            <p>
              <Link rel="noreferrer" to={{}} onClick={() => fetchPrivacyPolicy('privacyPolicy')}>
                Privacy Policy
              </Link>
              &nbsp;&nbsp;&nbsp;
              <Link rel="noreferrer" to={{}} onClick={() => fetchPrivacyPolicy('platformAccessAgreement')}>
                Platform Access Agreement
              </Link>
              &nbsp;&nbsp;&nbsp;
              <Link rel="noreferrer" to={{}} onClick={() => fetchPrivacyPolicy('termsAndConditions')}>
                Terms & Conditions
              </Link>
            </p>
            Copyright <Icon type="copyright" /> {new Date().getFullYear()} Luminia LLC, All rights Reserved.
          </>
        }
      />
    </Layout.Footer>
  );
};

export default FooterView;
